import { udApi } from '@udemy/ud-api';
export const fetchAggregatorTopics = async () => {
  const url = 'browse/aggregator/certification/navigation/';
  const response = await udApi.get(url);
  return response.data;
};
//# sourceMappingURL=fetch-aggregator-topics.js.map